import { useEffect, useMemo } from 'react';
import { validateImageSizeOnUpload } from '../../Helpers/image-upload-limiter';
import useTranslate from '../../Hooks/useTranslate';
import notify from '../../Style-guide/ToastMessage';
import UploadableImageWrapper from './style/uploadableImageWrapper';

const UploadableImage = ({ image, previewUrl, onImageChange, onImageRemove, index }) => {
  const inputId = `uploadable-image-${index}`;
  const tr = useTranslate();

  useEffect(() => {
    if (image) {
      validateImageSizeOnUpload(image).then(
        ({ isValid, message, translationKey, limit }) => {
          if (!isValid) {
            notify.info(
              tr(translationKey, { isError: true }).replace('{limit}', limit) || message
            );
            onImageRemove();
          }
        }
      );
    }
  }, [image, onImageRemove, tr]);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      onImageChange(file);
    }
  };

  const displayUrl = useMemo(
    () => (image ? URL.createObjectURL(image) : previewUrl || null),
    [image, previewUrl]
  );

  return (
    <UploadableImageWrapper>
      {displayUrl ? (
        <div className='image-container'>
          <img className='preview-image' src={displayUrl} alt='Preview' />
          <button className='remove-button' onClick={onImageRemove}>
            ✕
          </button>
        </div>
      ) : (
        <>
          <label htmlFor={inputId} className='no-image'>
            {tr('upload_photo')}
          </label>
          <input id={inputId} type='file' accept='image/*' onChange={handleChange} />
        </>
      )}
    </UploadableImageWrapper>
  );
};

export default UploadableImage;
